import React from 'react';
import IncidentListPage from '../../../../components/Incident/IncidentListPage/IncidentListPage';
import { ContentPage } from './MerchandiserLayout';

function MerchandiserIncidentListPage() {
  return (
    <ContentPage variant="elevation" sx={{ flex: '1', width: '100%' }}>
      <IncidentListPage />
    </ContentPage>
  );
}

export default MerchandiserIncidentListPage;
